import { gql } from "apollo-boost"

export const getTechnicalMonitoring = gql`
  query TechnicalMonitoring($id: ID!) {
    Submission:TechnicalMonitoring(id: $id) {
      specificObjectives {
        indicators {
          id
          goal
        }
        activities {
          id
          goal
        }
      }
      developmentObjectiveIndicators {
        id
        goal
      }
      generalObjectiveIndicators {
        id
        goal
      }
      technicalMonitoringReports {
        id
        key
        goal
        createdAt
        completed
      }
      projectBeneficiaries {
        id
      }
    }
  }
`